import { createReducer } from '../../../utilities';
import {
    FAIL_FETCH_STATS_MASTER_LEAGUES,
    REQUEST_FETCH_STATS_MASTER_LEAGUES,
    SUCCESS_FETCH_STATS_MASTER_LEAGUES
} from "../../../../actions/entities/statistics/masterLeague";


const initialState = {
    data: null,
    error: false,
    isFetching: false,
};

function requestFetch(state) {
    return {
        ...state,
        isFetching: true,
    };
}

function successFetch(state, action) {
    const { data } = action;
    return {
        ...state,
        data,
        isFetching: false,
    };
}

function failFetch(state, action) {
    const { error } = action;
    return {
        ...state,
        isFetching: false,
        error
    };
}

export default createReducer(initialState, {
    [REQUEST_FETCH_STATS_MASTER_LEAGUES]: requestFetch,
    [SUCCESS_FETCH_STATS_MASTER_LEAGUES]: successFetch,
    [FAIL_FETCH_STATS_MASTER_LEAGUES]: failFetch,
});



// WEBPACK FOOTER //
// ./src/reducers/app/statistics/masterLeague/created.js